rEvent.on('Window.doneResizing', function() {
    $('.js-slick .slick-list').css('height', '');
    $('.js-slick').slick('setPosition');
});

$(document).ready(function() {
    $('.js-slick').on('init', function(event, slick, currentSlide) {
        $('.js-countdown').each(function() {
            setCountdown($(this), $(this).attr('data-time'));
        });
    });

    new Swiper('.js-swiper', {
        navigation: {
            nextEl: '.js-swiper-next',
            prevEl: '.js-swiper-prev',
        },
        loop: true,
        autoplay: { delay: 4000 },
        speed: 300,
        lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 2,
        },
        on: {
            slideChangeTransitionStart: function() {
                bLazy.revalidate();
                $('.js-countdown').each(function() {
                    setCountdown($(this), $(this).attr('data-time'));
                });
            },
            init: function() {
                $('.js-countdown').each(function() {
                    setCountdown($(this), $(this).attr('data-time'));
                });
                bLazy.revalidate();
            },
        },
    });

    $('.js-slick').on('afterChange', function(event, slick, currentSlide) {
        bLazy.revalidate();

        $('.js-countdown').each(function() {
            setCountdown($(this), $(this).attr('data-time'));
        });
    });

    $('.jsShowAllCategories').on('click', function() {
        $(this)
            .parents('.index__categories__row')
            .find('.index__categories__col.hidden-xs')
            .removeClass('hidden-xs');
        $(this).remove();

        return false;
    });

    $('.index__products__tabs a').on('click', function() {
        $(this)
            .addClass('active')
            .siblings()
            .removeClass('active');
        $('.index__products__title').text($(this).attr('data-title'));
        $('.index__products__all').attr('href', $(this).attr('href'));
        $('.index__products__all span').text($(this).attr('data-all-title'));
        $('.index__products__content__listing').addClass('collapse');
        $(
            '.index__products__content__listing#' + $(this).attr('data-tab')
        ).removeClass('collapse');

        return false;
    });
});
